import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import NavigationV2 from './components/NavigationV2/NavigationV2.js';

ReactDOM.render(
    <NavigationV2/>,
    document.getElementById('mainHeader')
);